// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__XCV7F","nav__links":"Nav_nav__links__R7FNU","nav--extra":"Nav_nav--extra__mChrX"};